var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5257 3.14935C21.8205 3.33156 22 3.65342 22 4V17C22 17.3788 21.786 17.725 21.4472 17.8944L15.4472 20.8944C15.1657 21.0352 14.8343 21.0352 14.5528 20.8944L9 18.118L3.44721 20.8944C3.13723 21.0494 2.76909 21.0329 2.47427 20.8507C2.17945 20.6684 2 20.3466 2 20V7C2 6.62123 2.214 6.27497 2.55279 6.10557L8.55279 3.10557C8.83431 2.96481 9.16569 2.96481 9.44721 3.10557L15 5.88197L20.5528 3.10557C20.8628 2.95058 21.2309 2.96714 21.5257 3.14935ZM14 7.61803L10 5.61804V16.382L14 18.382V7.61803ZM16 18.382L20 16.382V5.61804L16 7.61803V18.382ZM8 16.382V5.61804L4 7.61804V18.382L8 16.382Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.6db50439087ea30402c5e6dd91df2c02.svg";
export { ForwardRef as ReactComponent };